import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { pointConfigurationQueries, SlabsQueries } from '@/services/pointConfiguration/pointConfiguration.queries';

export const usePointCategoryDetail = (pointCategoryId?: string) => {
  const { data, isLoading } = useQuery({
    ...pointConfigurationQueries.details(pointCategoryId ?? ''),
    enabled: Boolean(pointCategoryId),
  });

  return { category: data?.data, isLoading };
};

export const usePointSlabDetail = (pointSlabId?: string) => {
  const { data, isLoading } = useQuery({
    ...SlabsQueries.details(pointSlabId ?? ''),
    enabled: Boolean(pointSlabId),
  });

  return { slab: data?.data, isLoading };
};
